import { render, staticRenderFns } from "./language-modal-cmp.vue?vue&type=template&id=43d51508&scoped=true"
import script from "./language-modal-cmp.vue?vue&type=script&lang=js"
export * from "./language-modal-cmp.vue?vue&type=script&lang=js"
import style0 from "./language-modal-cmp.vue?vue&type=style&index=0&id=43d51508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d51508",
  null
  
)

export default component.exports